import FormEngine from '@form-engine/core-application';
import { ValidationType } from '@form-engine/core-application/types/form';
import { UploadState } from '../utils/upload-handling';
import { apiName, defaultCategory } from '../components/attachments-element';

const BsoAttachmentListValidation: ValidationType = (
    element,
    _value,
    session
) => {
    // only validate supported attachment element configurations
    if (
        element.type !== apiName ||
        !element.renderAsList ||
        !element.multiple ||
        !element.listSettings?.length
    ) {
        return null;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { uploads = [] } = (session.elements?.[element.id] ?? {}) as {
        uploads?: UploadState[];
    };

    const { c } = FormEngine.i18n;
    const label = element?.label ?? element?.name;

    for (const uploadSetting of element.listSettings) {
        const currentUploads =
            uploads?.filter(
                (u) => u.bsoCategory === uploadSetting.bsoCategory
            ) ?? [];

        const category = c(
            `attachment.bsoCategory.${uploadSetting.bsoCategory || defaultCategory}`
        );

        if (uploadSetting.required && !currentUploads.length) {
            return c('validation.attachmentListItemRequired', {
                label,
                category,
            });
        }

        if (uploadSetting.validationMaxAttachments) {
            const max = Number(uploadSetting.validationMaxAttachments);

            if (currentUploads.length > max) {
                return c('validation.attachmentListItemMaxAttachments', {
                    label,
                    category,
                    max,
                });
            }
        }

        if (uploadSetting.validationMaxAttachmentSize) {
            const max =
                Number(uploadSetting.validationMaxAttachmentSize) * 1024 * 1024;

            for (const { file } of currentUploads) {
                if (file.size > max) {
                    return c('validation.attachmentListItemMaxAttachmentSize', {
                        label,
                        category,
                        max: uploadSetting.validationMaxAttachmentSize,
                    });
                }
            }
        }
    }

    return null;
};

export default BsoAttachmentListValidation;
